export class CustomError extends Error {
  constructor(
    message: string,
    public code?: number,
  ) {
    super(message);
    this.name = 'CustomError';
  }
}

export function isError(variable: any): variable is Error {
  return variable instanceof Error;
}

export function convertToError(variable: any): Error {
  if (typeof variable === 'object' && variable !== null) {
    const error: CustomError = new CustomError(
      variable.message || 'Unknown error',
      variable.code,
    );
    Object.assign(error, variable);
    return error;
  }
  return new CustomError(String(variable));
}

export function ensureError(variable: any): Error {
  if (isError(variable)) {
    return variable;
  }
  return convertToError(variable);
}
